<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center">
      Data Peserta Sertifikasi
    </CCardHeader>

    <CCardBody>
      <!-- filter -->
      <FilterSertifikasi :searchData="searchDataPesertaSertifikasi"   />
      <!-- end filter -->
      <ul
        class="nav nav-tabs bg-active border-0 border-bottom-0"
        id="myTab"
        role="tablist"
      >
        <li class="nav-item" ref="tablunas">
          <div
            :class="tab_selected.aria_selected_lunas ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white'"
            id="home-tab"
            data-toggle="tab"
            href="#home"
            style="cursor: pointer"
            role="tab"
            aria-controls="home"
            @click="tabchange('lunas')"
            :aria-selected="tab_selected.aria_selected_lunas">
            Lunas
            <span class="badge badge-success text-white">{{ badges.totalLunas }}</span>
          </div>
        </li>
        <li class="nav-item">
          <div
            :class="tab_selected.aria_selected_belum_lunas ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white'"
            id="profile"
            data-toggle="tab"
            href="#profile"
            style="cursor: pointer"
            role="tab"
            aria-controls="profile"
            @click="tabchange('belum_lunas')"
            :aria-selected="tab_selected.aria_selected_belum_lunas">
            Belum Lunas
            <span class="badge badge-danger text-white">{{
              badges.totalBelumLunas
            }}</span>
          </div>
        </li>
        <li class="nav-item">
          <div
            :class="tab_selected.aria_selected_batal ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white'"
            id="batal-tab"
            data-toggle="tab"
            @click="tabchange('batal')"
            href="#batal"
            style="cursor: pointer"
            role="tab"
            aria-controls="batal"
            :aria-selected="tab_selected.aria_selected_batal">
            Lainnya
            <span class="badge badge-warning text-white">{{badges.totalLainnya}}</span>
          </div>
        </li>
      </ul>
      <CRow>
        <CCol sm="12" lg="12" md="12">
          <CDataTable
            style="widht: 100% !important"
            :items="items"
            :fields="get_data_status.status_biaya == 'lunas' ? fields : fieldsLainya"
            hover
            sorter>
            <template #no="{ index }">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>

            <template #no_anggota="{ item }">              
              <td class="py-2">{{ item.no_anggota ? item.no_anggota : "-" }}</td>
            </template>

            <template #email="{ item }">              
              <td class="py-2">{{ item.email ? item.email : "-" }}</td>
            </template>

            <template #jumlah_mata_ujian="{item}">
              <td class="py-2">{{ item.jumlah_mata_ujian }}</td>
            </template>
           
            <template #persyaratanDokumen="{ item }">
              <td class="py-2">
                {{ item.persyaratanDokumen ? item.persyaratanDokumen : "-" }}
              </td>
            </template>

            <template #nama_lengkap="{ item, index }">
              <td
                class="py-2 text-info"
                style="cursor: pointer"
                @click="detailUser(item, index)">
                {{ item.nama_lengkap ? item.nama_lengkap : "-" }}
              </td>
            </template>

            <template #tgl_daftar="{ item }">
              {{ item }}
              <td class="py-2">
                {{ item.tgl_daftar ? item.tgl_daftar : "-" }}
              </td>
            </template>

            <template #tanggal_daftar="{ item }">
              <td class="py-2">
                {{ item.tanggal_daftar ? item.tanggal_daftar : "-" }}
              </td>
            </template>

            <template #aksi="{ item }">
              <td class="py-2 text-center">
        
                <router-link :to="'/sertifikasi/data-peserta-sertifikasi/' +item.id_sertifikasi_peserta">
                
                  <CButton
                    v-c-tooltip="'Lihat Mata Uji Peserta'"
                    color="success"
                    class="btn-sm mr-2"
                    square>
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </CButton> 
                </router-link>

                <router-link
                  :to="'/sertifikasi/data-peserta/data-dokumen/' + item.id_sertifikasi_peserta">
                  <CButton
                    v-c-tooltip="'Lihat Dokumen Peserta'"
                    color="warning"
                    class="btn-sm text-white" square>
                    <i class="fa fa-file" aria-hidden="true"></i>
                  </CButton>
                </router-link>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float: right"
            :active-page.sync="currentPageDataPesertaSertifikasi"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
      <!-- Modal Detail User -->
      <ModalDetailPesertaSertifikasi
        :modalDetail="modalDetail"
        :title="modalTitle"
        :formData="formData"
        @closeModalDetail="closeModalDetail($event)"
      />
      <!-- End Modal -->
      <!-- Modal Pembatalan User -->
      <ModalPengajuanPembatalanSertifikasi
        :modalDetailPembatalan="modalDetailPembatalan"
        :title="modalTitleDetailPembatalan"
        :formData="formDataPembatalan"
        @closeModalPembatalan="closeModalPembatalan($event)"
      />
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
import DataPesertaService from "@/services/sertifikasi/data-peserta.service";
import MasterSertifikasiService from "@/services/sertifikasi/master-sertifikasi.service";

import { AlertUtils } from "@/mixins/AlertUtils";
import { PaginationDataPesertaSertifikasi } from "@/mixins/paginationType/PaginationDataPesertaSertifikasi";
import { exportUtils } from '@/mixins/exportUtils';
import { KategoriAnggota } from "@/mixins/master/KategoriAnggota";

import FilterSertifikasi from "@/components/sertifikasi/datapeserta/FilterSertifikasi";
import ModalDetailPesertaSertifikasi from "@/components/sertifikasi/datapeserta/ModalDetailPesertaSertifikasi";
import ModalPengajuanPembatalanSertifikasi from "@/components/sertifikasi/datapeserta/ModalPengajuanPembatalanSertifikasi";

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false,
  },
  {
    key: "no_anggota",
    label: "No Anggota",
    sorter: true,
    filter: false,
  },
  {
    key: "nama_lengkap",
    label: "Nama",
    sorter: true,
    filter: false,
  },
  {
    key: "email",
    label: "Email",
    sorter: true,
    filter: false,
  },
  {
    key: "jumlah_mata_ujian",
    label: "Jumlah Mata Uji",
    sorter: true,
    filter: false,
  }, 
  {
    key: "aksi",
    _style: "width:20%; text-align: center",
    sorter: false,
    filter: false,
  },
];

const fieldsLainya = [
  {
    key: "no",
    sorter: true,
    filter: false,
  },
  {
    key: "no_anggota",
    label: "No Anggota",
    sorter: true,
    filter: false,
  },
  {
    key: "nama_lengkap",
    label: "Nama",
    sorter: true,
    filter: false,
  },
  {
    key: "email",
    label: "Email",
    sorter: true,
    filter: false,
  },
  {
    key: "aksi",
    _style: "width:20%; text-align: center",
    sorter: false,
    filter: false,
  },
];

export default {
  mixins: [
    AlertUtils, 
    PaginationDataPesertaSertifikasi, 
    KategoriAnggota,
    exportUtils
  ],

  components: {
    FilterSertifikasi,
    ModalDetailPesertaSertifikasi,
    ModalPengajuanPembatalanSertifikasi,
  },

  watch : {
    'get_data_status.status_biaya' : function (val) {
      this.formFilter.status_pembayaran = val;
    }
  },

  data() {
    return {
      tab_selected: {
        aria_selected_lunas: true,
        aria_selected_belum_lunas: false,
        aria_selected_batal: false,
      },
      badges: {
        totalLunas: 0,
        totalBelumLunas: 0,
        totalLainnya: 0,
      },
      get_data_status: {
        status_biaya: "lunas",
      },
      modalDetailPembatalan: false,
      modalTitleDetailPembatalan: "Detail Pembatalan",
      formDataPembatalan: {},
      modalTitle: "Detail User",
      items: [],
      sertifikasi: "",
      kategori_anggota: "",
      formData: {
        nama_kategori: "",
        nama_lengkap: "",
        noTelephone: "",
        noTelephone: "",
        tangga_jatuh_tempo: "",
        tanggal_ujian: "",
        no_handphone: "",
        email: "",
        nama: "",
        noTelephone: "",
        password: "",
        id_user: "",
      },
      dataSertifikasi: [],
      details: [],
      fieldsLainya,
      fields,
      searchSertifikasi: "",
      status: false,
      myModal: false,
      modalDetail: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: [],
      loading: true,
    };
  },

  mounted() {
    
    // this.getData("0", this.pageSize, this.searchSertifikasi, this.id_sertifikasi,);
  },  

  methods: {
    syncSearch(value) {
      // comment console console.log(value)
      this.searchDataPesertaSertifikasi = value;
    },

    tabchange(value) {
      switch (value) {
        case "lunas":
          this.tab_selected.aria_selected_lunas = true;
          this.tab_selected.aria_selected_belum_lunas = false;
          this.tab_selected.aria_selected_batal = false;
          this.get_data_status.status_biaya = "lunas";
          this.getData(
            0,
            10,
            "default",
            this.formFilter.id_sertifikasi,
            this.formFilter.status_pembayaran,
            this.formFilter.periode
          );
          this.getCountLunas();
          this.getCountBelumLunas();
          this.getCountLainnya();
          break;
        case "belum_lunas":
          this.tab_selected.aria_selected_lunas = false;
          this.tab_selected.aria_selected_belum_lunas = true;
          this.tab_selected.aria_selected_batal = false;
          this.get_data_status.status_biaya = "belum_lunas";
          this.getCountLunas();
          this.getCountBelumLunas();
          this.getCountLainnya();

          this.getData(
            0,
            10,
            "default",
            this.formFilter.id_sertifikasi,
            this.formFilter.status_pembayaran,
            this.formFilter.periode
          );
          break;
        case "batal":
          this.tab_selected.aria_selected_lunas = false;
          this.tab_selected.aria_selected_belum_lunas = false;
          this.tab_selected.aria_selected_batal = true;
          this.get_data_status.status_biaya = "batal";
          this.getCountLunas();
          this.getCountBelumLunas();
          this.getCountLainnya();
          this.getData(
           0,
            10,
            "default",
            this.formFilter.id_sertifikasi,
            this.formFilter.status_pembayaran,
            this.formFilter.periode
          );

          break;
        default:
          break;
      }
    },

    getCountLunas() {
      DataPesertaService.getDataPeserta(
        0,
        10,
        "default",
        this.formFilter.id_sertifikasi,
        'lunas',
        this.formFilter.periode
      )
        .then((response) => {
          this.badges.totalLunas = response.data.data.totalElements;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getCountBelumLunas() {
      DataPesertaService.getDataPeserta(
        0,
        1,
        "default",
        this.formFilter.id_sertifikasi,
        'belum_lunas',
        this.formFilter.periode
      )
        .then((response) => {
          this.badges.totalBelumLunas = response.data.data.totalElements;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getCountLainnya() {
      DataPesertaService.getDataPeserta(
        0,
        10,
        "default",
        this.formFilter.id_sertifikasi,
        'batal',
        this.formFilter.periode
      )
        .then((response) => {
          this.badges.totalLainnya = response.data.data.totalElements;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    exportDataPeserta(value) {
      // if(this.form)
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      DataPesertaService.exportDataPeserta(
        value.periode,
        value.id_sertifikasi,
        value.status_pembayaran
      ).then(response => {
        loader.hide();
        this.exportDataCorupt(response.data, 'DataPesertaSertifikasi');
        this.alertExportSuccess();
      }).catch(error => {
        // comment console console.log(error)
        this.alertExportFailed();
        loader.hide()
      })
    },

    filterData(formFilter) {
      this.formFilter = formFilter;
      this.getData(
        0,
        10,
        "default",
        this.formFilter.id_sertifikasi,
        this.formFilter.status_pembayaran,
        this.formFilter.periode
      );
      this.getCountLunas();
      this.getCountBelumLunas();
      this.getCountLainnya();
    },

    postStatusPembatalan(formData) {      
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      DataPesertaService.putStatusPembatalan(formData)
        .then((response) => {
          this.getData(0, 10, "default", this.formFilter.id_sertifikasi, this.formFilter.status_pembayaran, this.formFilter.periode);
          loader.hide();
          this.modalDetailPembatalan = false;
          this.alertEditSuccess();
        })
        .catch((error) => {
          // comment console console.log(error);
          this.alertError();
        });
    },

    aksiPembatalan(item) {
      this.modalDetailPembatalan = true;
      this.formDataPembatalan = item;
    },    

    pilihStatusPembayaran(e) {
      this.modelStatusPembayaran = e.target.value;
      this.modelIdSertifikasi = "default";
      this.getData(
        "0",
        this.pageSize,
        this.searchSertifikasi,
        "default",
        this.modelStatusPembayaran
      );
    },

    pageChange() {
      this.getData(currentPage);
    },

    getData(
      currentPage,
      pageSize,
      filter,
      id_sertifikasi,
      statuspembayaran,
      periode
    ) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      var vm = this;

      var status_pembayaran = this.get_data_status.status_biaya;

      DataPesertaService.getDataPeserta(
        currentPage,
        pageSize,
        filter,
        id_sertifikasi,
        status_pembayaran,
        periode
      )
        .then((response) => {
          loader.hide();          
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPageDataPesertaSertifikasi =
            response.data.data.pageable.pageNumber + 1;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },


    detailUser(item, index) {
      this.modalDetail = true;
      this.formData = item;
    },

    changeSertifikasi(value) {
      this.modelStatusPembayaran = "default";
      this.modalDetailPembatalan = false;
      this.idSertifikasi = value.idSertifikasi;
      this.getData(
        "0",
        this.pageSize,
        "default",
        value.idSertifikasi,
        "default"
      );
    },

    changePageSizeDataPesertaSertifikasi(e) {
      this.changePageSize(e);
    },

    closeModalDetail(e) {
      if(e === false) {
        this.modalDetail = false;
      }
    },

    closeModalPembatalan(e) {
      if(e === false) {
        this.modalDetailPembatalan = false;
      }
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
  button:disabled {
    cursor: no-drop;
  }
</style>